export default "__VITE_ASSET__CUx0hm54__"